import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

Modal.setAppElement("#root");

export default function Create_candidate() {
  const title = "Add Applicant ";
  const navigate = useNavigate();
  const [job, setJob] = useState([]);
  const [user, setUser] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    jobId: "",
    userId: "",
    address: "",
    description: "",
    phoneNumber: "",
    licenseNumber: "",
    aadharNumber: "",
    email: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/jobs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setJob(response.data.jobs);
      } catch (error) {
        console.error("Error fetching users:", error);
        setJob([]);
      }
    };
    fetchJobs();
  }, []);

  const handleJobChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      jobId: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // ✅ Only ACTIVE Supervisors
        const supervisors = response.data.users.filter(
          (user) =>
            user?.id_generalStaffType?.name === "Supervisor" &&
            user?.status === "Active",
        );

        setUser(supervisors);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUser([]);
      }
    };

    fetchUsers();
  }, []);

  const handleUserChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      userId: selectedOption ? selectedOption.value : null,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = "Name is required.";
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone Number is required.";
    }
    if (!formData.jobId) {
      newErrors.jobId = "Job ID is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const onChangeHandler = (event) => {
  //   const { name, value } = event.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;

    if (name === "resume") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        resume: files?.[0] || null,
      }));
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // const onSubmitHandler = async (event) => {
  //   event.preventDefault();

  //   if (!validateForm()) {
  //     return;
  //   }

  //   const token = localStorage.getItem("token");
  //   const userRole = localStorage.getItem("userRole");

  //   // Detect admin submission
  //   const isAdminSubmission =
  //     userRole === "superadmin" ||
  //     userRole === "admin" ||
  //     userRole === "clientmanager";

  //   if (!token) {
  //     console.error("No token found");
  //     return;
  //   }

  //   const payload = {
  //     name: formData.name,
  //     description: formData.description,
  //     jobId: formData.jobId,
  //     userId: formData.userId,
  //     address: formData.address,
  //     phoneNumber: formData.phoneNumber,
  //     licenseNumber: formData.licenseNumber,
  //     aadharNumber: formData.aadharNumber,

  //     // ⭐ THIS IS WHAT BACKEND WILL CHECK
  //     isAdminSubmission: isAdminSubmission,
  //   };

  //   console.log("Payload being sent:", payload);

  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/applicants`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     );

  //     if (response.status === 201) {
  //       navigate("/candidate");
  //     } else {
  //       console.error("Submission failed:", response.statusText);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error.response ? error.response.data : error);
  //   }
  // };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole");

    const isAdminSubmission =
      userRole === "superadmin" ||
      userRole === "admin" ||
      userRole === "clientmanager";

    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();

    data.append("name", formData.name);
    data.append("description", formData.description);
    data.append("jobId", formData.jobId);

    if (formData.userId) {
      data.append("userId", formData.userId);
    }

    data.append("address", formData.address);
    data.append("phoneNumber", formData.phoneNumber);

    if (formData.licenseNumber) {
      data.append("licenseNumber", formData.licenseNumber);
    }

    if (formData.aadharNumber) {
      data.append("aadharNumber", formData.aadharNumber);
    }

    if (formData.email) {
      data.append("email", formData.email);
    }

    data.append("isAdminSubmission", isAdminSubmission);

    if (formData.resume) {
      data.append("resume", formData.resume);
    }

    // Debug FormData
    for (let [key, value] of data.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/applicants`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/candidate");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="name">
                  <b>Name* </b>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  className="form-control"
                  value={formData.name}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="phoneNumber">
                  <b>Phone Number* </b>
                </label>
                <input
                  type="number"
                  name="phoneNumber"
                  placeholder="PhoneNumber"
                  className="form-control"
                  value={formData.phoneNumber}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="email">
                  <b>Email</b>
                </label>

                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  className="form-control"
                  value={formData.email}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="aadharNumber">
                  <b>Adhar Number </b>
                </label>
                <input
                  type="number"
                  name="aadharNumber"
                  placeholder="Aadhar Number"
                  className="form-control"
                  value={formData.aadharNumber}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="licenseNumber">
                  <b>License Number </b>
                </label>
                <input
                  type="number"
                  name="licenseNumber"
                  placeholder="License Number"
                  className="form-control"
                  value={formData.licenseNumber}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="jobId">
                  <b>JOB ID *</b>
                </label>

                <Select
                  name="jobId"
                  options={job.map((job) => ({
                    value: job._id, // send _id
                    label: job.title, // show title
                  }))}
                  onChange={(selectedOption) => handleJobChange(selectedOption)}
                  classNamePrefix="select"
                />

                {errors.jobId && <p className="text-danger">{errors.jobId}</p>}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="userId">
                  <b>Supervisor</b>
                </label>

                <Select
                  name="userId"
                  options={user.map((user) => ({
                    value: user._id, // send _id
                    label: user.name, // show title
                  }))}
                  onChange={(selectedOption) =>
                    handleUserChange(selectedOption)
                  }
                  classNamePrefix="select"
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="address">
                  <b> Address * </b>
                </label>
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  className="form-control"
                  value={formData.address}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="resume">
                  <b>Resume</b>
                </label>

                <input
                  type="file"
                  name="resume"
                  className="form-control"
                  onChange={onChangeHandler}
                  accept=".pdf,.doc,.docx"
                />
              </div>

              <div className="col-md-6 mt-3"></div>
              <div className="col-12 mt-3">
                <label htmlFor="description">
                  <b>Descriptions </b>
                </label>
                <textarea
                  name="description"
                  type="text"
                  placeholder="Enter Description"
                  rows="5"
                  className="form-control"
                  value={formData.description}
                  onChange={onChangeHandler}
                ></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Applicant
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
